import { app } from '../../../../app';
import { Controller } from './software-license-management-edit.controller';

app.component('companySoftwareLicenseManagementEdit', {
    bindings: {
        companyId: '<',
        softwareLicenseManagementInfos: '<',
        slmi: '<',
    },
    controller: Controller,
    templateUrl: require('./software-license-management-edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/edit/software-license-management-edit.component.js